/**
 * Notification Slice — Types & Initial State
 *
 * Global notification queue. Any page/component can dispatch
 * addNotification() and it renders at the app level.
 */

export type NotificationType = 'error' | 'warning' | 'success' | 'info';

export interface AppNotification {
  id: string;
  type: NotificationType;
  header: string;
  content?: string;
  dismissible?: boolean;
}

export interface NotificationState {
  items: AppNotification[];
}

export const notificationInitialState: NotificationState = {
  items: [],
};
